var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObliqueStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29289 24.6687L1.58579 25.3758L2.29289 26.0829L3.9171 27.7071L4.62421 28.4142L5.33131 27.7071L27.7071 5.33131L28.4142 4.62421L27.7071 3.9171L26.0829 2.29289L25.3758 1.58579L24.6687 2.29289L2.29289 24.6687Z",
    fill: "white",
    stroke: "transparent",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObliqueStroke);
export default __webpack_public_path__ + "static/media/oblique-stroke.61c4821f51f2d17571d45fe14bd0b544.svg";
export { ForwardRef as ReactComponent };